import React, { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
const VizWrapper = forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
>(({ children, className, ...rest }, ref) => {
  return (
    <div
      ref={ref}
      className={twMerge("px-8 py-12 md:py-[60px] xl:py-20", className)}
      {...rest}
    >
      {children}
    </div>
  );
});
export default VizWrapper;
